import { render } from "./WorkShiftEmployeeAutocomplete.vue?vue&type=template&id=24c42a2d"
import script from "./WorkShiftEmployeeAutocomplete.vue?vue&type=script&lang=js"
export * from "./WorkShiftEmployeeAutocomplete.vue?vue&type=script&lang=js"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__